/**
 *
 */
export var BoundingVolumeType;
(function (BoundingVolumeType) {
    /**
     *
     */
    BoundingVolumeType[BoundingVolumeType["SPHERE"] = 0] = "SPHERE";
    /**
     *
     */
    BoundingVolumeType[BoundingVolumeType["SPHERE_FAST"] = 1] = "SPHERE_FAST";
    /**
     *
     */
    BoundingVolumeType[BoundingVolumeType["SPHERE_BOUNDS"] = 2] = "SPHERE_BOUNDS";
    /**
     *
     */
    BoundingVolumeType[BoundingVolumeType["SPHERE_BOUNDS_FAST"] = 3] = "SPHERE_BOUNDS_FAST";
    /**
     *
     */
    BoundingVolumeType[BoundingVolumeType["BOX"] = 4] = "BOX";
    /**
     *
     */
    BoundingVolumeType[BoundingVolumeType["BOX_FAST"] = 5] = "BOX_FAST";
    /**
     *
     */
    BoundingVolumeType[BoundingVolumeType["BOX_BOUNDS"] = 6] = "BOX_BOUNDS";
    /**
     *
     */
    BoundingVolumeType[BoundingVolumeType["BOX_BOUNDS_FAST"] = 7] = "BOX_BOUNDS_FAST";
    /**
     *
     */
    BoundingVolumeType[BoundingVolumeType["NULL"] = 8] = "NULL";
})(BoundingVolumeType || (BoundingVolumeType = {}));
